module.exports = __webpack_public_path__ + "img/IMAGE 5.732960bc.png";